import { PurchaseOrderReportUIFilters } from '@/shared/ui-models/purchase-order-report.ui-model';

export const initialPurchaseOrderReportFiltersValues: PurchaseOrderReportUIFilters = {
  startDate: null,
  endDate: null,
  status: [],
  autoProfitMarginFrom: '',
  autoProfitMarginTo: ''
};

export const validatePurchaseOrderReportFiltersForm = (
  fieldValues: PurchaseOrderReportUIFilters,
  errors: { [key: string]: string },
  setErrors: (error: any) => void,
  t: (key: string) => string
) => {
  const temp: { [key: string]: unknown } = { ...errors };

  if ('startDate' in fieldValues)
    temp.startDate = fieldValues.startDate ? '' : t('REPORTS_MODULE.PURCHASE_ORDERS_REPORT.VALIDATION.START_DATE_REQUIRED');

  // endDate should be greater than startDate
  if (fieldValues.startDate && fieldValues.endDate) {
    if (fieldValues.startDate > fieldValues.endDate) {
      temp.endDate = t('REPORTS_MODULE.PURCHASE_ORDERS_REPORT.VALIDATION.END_DATE_GREATER_THAN_START');
    } else {
      temp.endDate = '';
    }
  }

  if (fieldValues.autoProfitMarginFrom !== '' && fieldValues.autoProfitMarginTo !== '') {
    if (Number(fieldValues.autoProfitMarginTo) < Number(fieldValues.autoProfitMarginFrom)) {
      temp.autoProfitMarginTo = t('REPORTS_MODULE.PURCHASE_ORDERS_REPORT.VALIDATION.PROFIT_MARGIN_TO_GREATER_THAN_FROM');
    } else {
      temp.autoProfitMarginTo = '';
    }
  }

  setErrors({
    ...temp
  });

  const isValidForm = Object.values(temp).every((x) => x === '');
  if (isValidForm) {
    return { valid: true, error: '' };
  } else {
    return {
      valid: false,
      error: t('REPORTS_MODULE.PURCHASE_ORDERS_REPORT.VALIDATION.FILL_MANDATORY_DATA')
    };
  }
};
